import { useSelector } from 'react-redux';

import { actions } from '@/ui/flux';
import selectors from '@/ui/flux/selectors';

function useModal() {
  const modal = useSelector(selectors.modal.displayed);

  if (!modal) {
    return null;
  }

  return {
    ...modal,
    onClose: (data?: unknown) => {
      modal.onClose?.(data);
      actions.modal.hide({ id: modal.id });
    },
  };
}

export default useModal;
